// Хук для матрицы доступов по ЛПУ
import { useQuery } from '@tanstack/react-query'
import { fetchLpuAccessMatrix } from '@/api/lpuAccessMatrix'

/**
 * Загружает матрицу доступов для ЛПУ по коду.
 * Данные кэшируются 60 сек. Запрос пропускается если code пустой.
 */
export const useLpuAccessMatrix = (code: string | undefined) =>
  useQuery({
    queryKey: ['lpu-access-matrix', code],
    queryFn: () => fetchLpuAccessMatrix(code!),
    enabled: Boolean(code),
    staleTime: 60_000,
    retry: 1,
  })
